module.exports = __webpack_public_path__ + "img/mouth-1-7.51f126a7.svg";